module.exports = __webpack_public_path__ + "img/500@2x.f95275d7.png";